import { render } from "./CheckableTag.vue?vue&type=template&id=34e2408d"
import script from "./CheckableTag.vue?vue&type=script&lang=ts"
export * from "./CheckableTag.vue?vue&type=script&lang=ts"
script.render = render

export default script